;(function( window, document, bq ){ window.jQuery(function($) { 'use strict';

bq.createRelation = function(element, options) {
    this.$el = $(element);
    this.options = options;
    this._currentDirection = null;
    this._selectedProductData = null;
    this._fromProductContext = null;
};

bq.createRelation.DEFAULTS = {
    searchUrl: '',
    createRelationsUrl: '',
    supplierImageBaseUrl: '',
    labels: {
        creating: 'Creating...',
        createRelation: 'Create Relation',
        creatingRelation: 'Creating relation...',
        createSuccess: 'Relation created successfully!',
        createFailed: 'Failed to create relation',
        missingContext: 'Error: Product context is missing. Please close and try again.',
        missingProductIds: 'Product IDs are required to create a relation. Please re-select the product.',
        searchPlaceholder: 'Type to search products...',
        creatingFrom: 'Creating relation FROM',
        to: 'TO',
        cancel: 'Cancel'
    }
};

bq.createRelation.prototype = {
    init: function() {
        if (typeof window.bqIsCreatingRelation === 'undefined') {
            window.bqIsCreatingRelation = false;
        }
        this._bindEvents();
        this._observeAndInit();
    },

    _id: function() {
        return this.$el.data('modal-id');
    },

    _defaultSupplierImageUrl: function() {
        return this.options.supplierImageBaseUrl + 'placeholder.jpg';
    },

    _imageHtml: function(imageUrl, supplierId, size) {
        return bq.recommendations.buildImageHtml(imageUrl, supplierId, this.options.supplierImageBaseUrl, size);
    },

    _escHTML: function(s) {
        return $('<div/>').text(s || '').html();
    },

    _initForm: function() {
        this._$step1 = $('#bqCreateRelation-step1');
        this._$step2 = $('#bqCreateRelation-step2');
        this._$directionInfo = $('#bqCreateRelation-direction-info');
        this._$selectedProduct = $('#bqCreateRelation-selected-product');
        this._$selectedInfo = $('#bqCreateRelation-selected-info');
        this._$saveBtn = $('#bqCreateRelation-save-btn');
        this._$status = $('#bqCreateRelation-status');
        this._$productSearch = $('#bqCreateRelation-product-search');

        if (window.bqOpenCreateRelationFor) {
            this._fromProductContext = window.bqOpenCreateRelationFor;
        } else if (this.$el.attr('data-supplier-id') && this.$el.attr('data-sku')) {
            this._fromProductContext = {
                supplier_id: this.$el.attr('data-supplier-id'),
                sku: this.$el.attr('data-sku'),
                product_id: this.$el.attr('data-product-id') || ''
            };
        }
    },

    _bindEvents: function() {
        var self = this;

        $(document).off('click.createRelation');

        $(document).on('click.createRelation', '#bqCreateRelation-from-btn', function(e) {
            e.preventDefault(); e.stopPropagation();
            self._initForm();
            self._currentDirection = 'from';
            self._showStep2();
        });

        $(document).on('click.createRelation', '#bqCreateRelation-to-btn', function(e) {
            e.preventDefault(); e.stopPropagation();
            self._initForm();
            self._currentDirection = 'to';
            self._showStep2();
        });

        $(document).on('click.createRelation', '#bqCreateRelation-back-btn', function(e) {
            e.preventDefault(); e.stopPropagation();
            self._showStep1();
        });

        $(document).on('click.createRelation', '#bqCreateRelation-save-btn', function(e) {
            e.preventDefault(); e.stopPropagation();
            self._handleSave();
        });

        $(document).off('click.createRelationCancel', '.create-relation-modal-cancel')
            .on('click.createRelationCancel', '.create-relation-modal-cancel', function(e) {
                e.preventDefault();
                $(this).closest('.modal').modal('hide');
            });

        $(document).off('hidden.bs.modal.createRelation')
            .on('hidden.bs.modal.createRelation', function(e) {
                var $closedModal = $(e.target);
                if ($closedModal.find('.create-relation-form-content').length > 0) {
                    self._showStep1();
                    var $search = $('#bqCreateRelation-product-search');
                    if ($search.length && $search.data('select2')) { $search.select2('destroy'); }
                    $('#bqCreateRelation-message').val('');
                    $('#bqCreateRelation-selected-product').hide();
                    $('#bqCreateRelation-status').hide();
                    $('#bqCreateRelation-save-btn').prop('disabled', false).text(bq.messages.recommendations.createRelation);
                    window.bqOpenCreateRelationFor = null;
                    self._fromProductContext = null;
                    self._currentDirection = null;
                    self._selectedProductData = null;
                    window.bqIsCreatingRelation = false;
                }
            });

        $(document).off('createRelationFormInserted.createRelation')
            .on('createRelationFormInserted.createRelation', function() {
                setTimeout(function() {
                    self._initForm();
                    self._showStep1();
                    var $search = $('#bqCreateRelation-product-search');
                    if ($search.length && $search.data('select2')) { $search.select2('destroy'); }
                }, 50);
            });
    },

    _observeAndInit: function() {
        var self = this;
        var modalId = this._id();

        if ($('[data-modal-id="' + modalId + '"]').length > 0) {
            setTimeout(function() { self._initForm(); }, 100);
        } else {
            var observer = new MutationObserver(function() {
                if ($('[data-modal-id="' + modalId + '"]').length > 0) {
                    observer.disconnect();
                    setTimeout(function() { self._initForm(); }, 100);
                }
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    },

    _showStep1: function() {
        this._$step1 && this._$step1.show();
        this._$step2 && this._$step2.hide();
        this._$saveBtn && this._$saveBtn.hide();
        this._$status && this._$status.hide();
        this._currentDirection = null;
        this._selectedProductData = null;
    },

    _showStep2: function() {
        this._initForm();

        var labels = bq.messages.recommendations;
        if (!this._fromProductContext || !this._fromProductContext.supplier_id || !this._fromProductContext.sku) {
            this._$status.removeClass('alert-success alert-danger alert-warning').addClass('alert-danger')
                .text(labels.missingContext).show();
            return;
        }

        this._$step1.hide();
        this._$step2.show();

        var fromLabel = this._fromProductContext.supplier_id + ' - ' + this._fromProductContext.sku;
        var dirHtml = '';
        if (this._currentDirection === 'from') {
            dirHtml = '<strong>' + labels.creatingFrom + ':</strong> ' + this._escHTML(fromLabel) + '<br/>';
            dirHtml += '<strong>' + labels.to + ':</strong> (select product below)';
        } else {
            dirHtml = '<strong>' + labels.creatingFrom + ':</strong> (select product below)<br/>';
            dirHtml += '<strong>' + labels.to + ':</strong> ' + this._escHTML(fromLabel);
        }
        this._$directionInfo.html(dirHtml);

        this._initProductSearch();
    },

    _initProductSearch: function() {
        var self = this;
        var $productSearch = this._$productSearch;

        if (!$productSearch || !$productSearch.length) { return; }

        if ($productSearch.data('select2')) { $productSearch.select2('destroy'); }

        var supplierImageBaseUrl = this.options.supplierImageBaseUrl;
        var defaultSupplierImageUrl = this._defaultSupplierImageUrl();

        function esc(s) { return $('<div/>').text(s || '').html(); }

        function getImgHtml(imageUrl, supplierId, size) {
            var parsedSupplierId = parseInt(supplierId, 10);
            var supplierFallback = parsedSupplierId ? (supplierImageBaseUrl + parsedSupplierId + '.jpg') : defaultSupplierImageUrl;
            var resolvedImageUrl = imageUrl ? String(imageUrl) : supplierFallback;
            var ea = function(v) { return String(v).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;'); };
            return '<img src="' + ea(resolvedImageUrl) + '" alt="" class="rec-img--bordered rec-img--sm" data-fallback-state="primary" data-supplier-fallback="' + ea(supplierFallback) + '" data-default-fallback="' + ea(defaultSupplierImageUrl) + '" onerror="bqHandleRecommendationImageError(this)" />';
        }

        $productSearch.select2({
            placeholder: bq.messages.recommendations.searchPlaceholder,
            allowClear: true,
            minimumInputLength: 2,
            ajax: {
                url: self.options.searchUrl,
                type: 'GET',
                dataType: 'json',
                quietMillis: 250,
                data: function(term, page) { return { q: term || '', page: page || 1, page_limit: 20 }; },
                results: function(data) {
                    if (!data || typeof data !== 'object') { return { results: [], more: false }; }
                    return { results: (data.results && Array.isArray(data.results)) ? data.results : [], more: !!(data && data.more) };
                }
            },
            formatResult: function(item) {
                if (!item) { return ''; }
                var d = item.data || item;
                var imgHtml = getImgHtml(d.image, d.supplier_id || d.supplier, 36);
                var html = '<div class="rec-search-result">' + imgHtml + '<div>';
                html += '<div class="rec-search-result__name">' + esc(d.name || '') + '</div>';
                html += '<div class="rec-search-result__meta">';
                var sup = d.supplier_name || (d.supplier_id ? 'Supplier #' + d.supplier_id : '');
                if (sup) { html += '<span>' + esc(sup) + '</span>'; }
                if (d.supplier_sku || d.sku) { html += (sup ? ' &middot; ' : '') + '<span>SKU: ' + esc(d.supplier_sku || d.sku) + '</span>'; }
                html += '</div></div></div>';
                return html;
            },
            formatSelection: function(item) {
                if (!item) { return ''; }
                var d = item.data || item;
                var parts = [];
                if (d.supplier_name) { parts.push(d.supplier_name); } else if (d.supplier_id || d.supplier) { parts.push('Supplier #' + (d.supplier_id || d.supplier)); }
                if (d.supplier_sku || d.sku) { parts.push(d.supplier_sku || d.sku); }
                if (d.name) { parts.push(d.name); }
                return parts.length > 0 ? parts.join(' · ') : (item.text || '');
            },
            escapeMarkup: function(m) { return m; }
        }).on('change', function() {
            var sel = $(this).select2('data');
            if (!sel || !sel.data) {
                self._selectedProductData = null;
                self._$selectedProduct.hide();
                self._$saveBtn.hide();
                return;
            }
            self._selectedProductData = $.extend({}, sel, sel.data || {});
            var supplierLabel = self._selectedProductData.supplier_name || ('Supplier #' + (self._selectedProductData.supplier_id || self._selectedProductData.supplier || ''));
            var html = '<p class="rec-selected-info__name"><strong>' + esc(self._selectedProductData.name || '') + '</strong></p>';
            html += '<p class="rec-selected-info__meta">';
            html += esc(supplierLabel) + ' | SKU: ' + esc(self._selectedProductData.supplier_sku || self._selectedProductData.sku || '');
            var pid = self._selectedProductData.product_id || self._selectedProductData.id;
            if (pid) { html += ' | ID: ' + esc(pid); }
            html += '</p>';
            self._$selectedInfo.html(html);
            self._$selectedProduct.show();
            self._$saveBtn.show();
        });
    },

    _handleSave: function() {
        var self = this;
        var labels = bq.messages.recommendations;

        if (window.bqIsCreatingRelation) { return; }
        if (!this._selectedProductData || !this._currentDirection || !this._fromProductContext) { return; }

        window.bqIsCreatingRelation = true;
        this._$saveBtn.prop('disabled', true).text(labels.creating);
        this._$status.removeClass('alert-success alert-danger alert-warning').addClass('alert-info')
            .text(labels.creatingRelation).show();

        var currentProductId = String(this._fromProductContext.product_id || '');
        var selectedProductId = String(this._selectedProductData.product_id || this._selectedProductData.id || '');
        var productFrom = this._currentDirection === 'from' ? currentProductId : selectedProductId;
        var productTo   = this._currentDirection === 'from' ? selectedProductId : currentProductId;

        if (!productFrom || !productTo) {
            this._$status.removeClass('alert-info alert-success alert-warning').addClass('alert-danger')
                .text(labels.missingProductIds).show();
            this._$saveBtn.prop('disabled', false).text(labels.createRelation);
            window.bqIsCreatingRelation = false;
            return;
        }

        $.ajax({
            url: this.options.createRelationsUrl,
            method: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({
                product_id_from: productFrom,
                product_id_to: productTo
            })
        }).done(function() {
            self._$status.removeClass('alert-info alert-danger alert-warning').addClass('alert-success')
                .text(labels.createSuccess);
            setTimeout(function() {
                self.$el.closest('.modal').modal('hide');
                $(document).trigger('bqRelationCreated');
                window.bqIsCreatingRelation = false;
            }, 1000);
        }).fail(function(xhr) {
            var errorMsg = labels.createFailed;
            if (xhr.responseJSON && xhr.responseJSON.error) {
                errorMsg += ': ' + xhr.responseJSON.error;
            }
            self._$status.removeClass('alert-info alert-success alert-warning').addClass('alert-danger').text(errorMsg);
            self._$saveBtn.prop('disabled', false).text(labels.createRelation);
            window.bqIsCreatingRelation = false;
        });
    }
};

var oldCreateRelation = $.fn.createRelation;
$.fn.createRelation = function(option) {
    return this.each(function() {
        var $this = $(this);
        var data = $this.data('bq.createRelation');
        var options = $.extend(true, {}, bq.createRelation.DEFAULTS, $this.data(), typeof option === 'object' && option);
        if (!data) { $this.data('bq.createRelation', (data = new bq.createRelation(this, options))); }
        data.init();
    });
};
$.fn.createRelation.Constructor = bq.createRelation;
$.fn.createRelation.noConflict = function() { $.fn.createRelation = oldCreateRelation; return this; };

bq.createRelationInit = function() {
    $('[data-bq="create-relation"]:not([data-initialized])').each(function() {
        $(this).createRelation($(this).data());
    });
};
bq.init.push(bq.createRelationInit);
bq.createRelationInit();

});}( window, document, bq));
